var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("send-list", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading",
        value: _vm.isBusy,
        expression: "isBusy",
      },
    ],
    ref: "list",
    attrs: {
      "base-url": _vm.baseUrl,
      margin: 16,
      "contact-search-url": _vm.contactSearchUrl,
    },
    on: {
      "quick-message": _vm.onSendQuickMessage,
      "email-message": _vm.onEmailMessage,
      edit: _vm.onEdit,
      delete: _vm.onDelete,
      change: _vm.onChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }